import { Snackbar } from "@mui/material";
import React, { useEffect, useState } from "react";

const InternetConnectionMonitor = () => {
  const [isOnline, setIsOnline] = useState(window.navigator.onLine);
  const [isSlowConnection, setIsSlowConnection] = useState(false);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    const connection =
      navigator.connection ||
      navigator.mozConnection ||
      navigator.webkitConnection;

    const handleConnectionChange = () => {
      if (connection) {
        const { effectiveType } = connection;

        if (effectiveType === "slow-2g" || effectiveType === "2g") {
          setIsSlowConnection(true);
        } else {
          setIsSlowConnection(false);
        }
      }
    };

    connection?.addEventListener("change", handleConnectionChange);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
      connection?.removeEventListener("change", handleConnectionChange);
    };
  }, []);

  return (
    <div>
      {!isOnline && (
        <Snackbar
          open={true}
          message='Your internet connection is down'
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        />
      )}
      {isOnline && isSlowConnection && (
        <Snackbar
          open={true}
          message='Your internet connection is not stable'
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        />
      )}
    </div>
  );
};

export default InternetConnectionMonitor;
